import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fd6883e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("自动匹配")
const _hoisted_3 = {
  class: "tftable",
  border: "1"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "titleColumn" }, "订单号:", -1))
const _hoisted_5 = { colspan: "8" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确认无误")
const _hoisted_7 = ["rowspan"]
const _hoisted_8 = ["rowspan"]
const _hoisted_9 = ["rowspan"]
const _hoisted_10 = ["rowspan"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("修改")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-10" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10" }, null, -1))

import { ref, Ref, reactive, computed, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { getNumber, formatTime } from '@/utils/index'
import Api from '@/http/modules/index'
import { format } from 'mathjs'

export default /*#__PURE__*/_defineComponent({
  props: {
    isMatched: null
  },
  setup(__props: any) {

const props = __props as {
  isMatched: number
}

let {
  'POST/order_cost/unmatched/query': fetchList,
  // 订单成本类别匹配_确认无误
  'POST/order_cost/unmatched/match': matchApi,
  // 订单成本类别匹配_自动匹配
  'POST/order_cost/unmatched/auto_match': auto_matchApi,
  // 成本类型下拉框
  'GET/order_cost/unmatched/cost_drop_list': cost_drop_listApi,
  // 订单成本匹配_修改
  'PATCH/order_cost/unmatched/update_cost_type': update_cost_typeApi,
  // 订单成本类别匹配记录_分页查询
  'POST/order_cost_record/query': recordListApi,
} = Api



const maxHeight = ref(window.innerHeight)
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchConfig = ref([
  {
    type: "TIME",
    label: "订单创建日期",
    value: [],
    upKey: 'date',
    upProps: { startKey: 'from', endKey: 'to' },
    props: {
      type: 'daterange',
      clearable: true,
    }
  },
])
const searchHandle = (params: any) => {
  fetchData({
    query: {
      createdFrom: params.from,
      createdTo: params.to,
      isMatched: props.isMatched,
    }
  })
}

const tbData = computed(() => {
  return MI_tableData.value.map(row => {
    row.orderList = (row.languageServiceList || []).concat(row.itList || []).concat(row.designList || [])
    row.rowspan = row.costRtList?.length > row.orderList.length ? row.costRtList.length : row.orderList.length
    return row
  })
})

let modfiyOption: any = ref([])
onBeforeMount(() => {
  cost_drop_listApi().then((rep: any) => {
    modfiyOption.value = Object.keys(rep).map(key => {
      return {
        value: key,
        label: key,
        children: rep[key].map((e: string) => ({label: e, value: e}))
      }
    })

  })
})


// 修改
const modifyFg = ref<boolean>(false)
const modifyValue = ref<string[]>([])
let modifyRow: {id?: number, orderId?: number} = {}
const modifyHandle = (obj: {id: number, typeAlias: string, type: string, orderId: number}) => {
  modifyRow = obj
  modifyValue.value = [obj.typeAlias, obj.type]
  modifyFg.value = true
}

const isLoadingModify = ref<boolean>(false)
const submitModify = () => {
  const type = modifyValue.value[modifyValue.value.length - 1]

  isLoadingModify.value = true
  update_cost_typeApi({orderId: modifyRow.orderId, costId: modifyRow.id, type}).then(() => {
    ElMessage.success('成功')
    modifyFg.value = false
    fetchData(MI_params)
  }).finally(() => {
    isLoadingModify.value = false
  })
  
}

// 确认无误
const matchHandle = (row: {id: string, no: string}) => {

  ElMessageBox.confirm(
    `是否确认:${row.no}?`,
    '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    MI_identify.value = true
    return matchApi({orderId: row.id})
  }).then(() => {
    ElMessage.success('成功')
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })


}

// 自动匹配
const isShowAutoMatch = ref<boolean>(false)
const autoMatchConfig = ref([
  {
    type: "TIME",
    label: "订单创建日期",
    value: '',
    upKey: 'dates',
    props: {
      type: 'month',
      clearable: true,
    }
  },
])
const autoMatchHandle = () => {
  MI_modifyForm({}, autoMatchConfig, isShowAutoMatch, async (params: object) => {
    await auto_matchApi({
      createTime: {
        from: dayjs(params.dates).startOf('month').format('YYYY-MM-DD'),
        to: dayjs(params.dates).endOf('month').format('YYYY-MM-DD'),
      }
    })
    ElMessage.success('成功')
    isShowAutoMatch.value = false
    fetchRecord()
  })
}


// 自动匹配,展示历史数据
const { 
  MI_tableData: RecordDt, fetchData: fetchRecord, page: RecordPage, size: RecordSize, MI_total: RecordTotal, MI_pageChange: RecordPagePgCg,
  MI_sizeChange: RecordSzCg, MI_identify: RecordFg, MI_params: RecordParams
} = new tbMix(recordListApi)
const isShowRecord = ref<boolean>(false)
const showHistory = () => {
  isShowRecord.value = true
  fetchRecord()
}

// ----------
const formatNumber = (numb: number) => {
  if(!numb){
    return '-'
  }
  return getNumber(numb) + '$'
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点击搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
            initSearch: true,
            title: true,
            searchConfig: searchConfig.value,
          }, { onSearchFn: searchHandle }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showHistory()))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      class: "tableContent",
      style: _normalizeStyle({'max-height': maxHeight.value - 280 + 'px'})
    }, [
      _withDirectives((_openBlock(), _createElementBlock("table", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tbData), (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            _createElementVNode("tr", null, [
              _hoisted_4,
              _createElementVNode("th", _hoisted_5, _toDisplayString(item.no), 1),
              _createElementVNode("th", null, [
                (props.isMatched == 0)
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      type: "primary",
                      onClick: ($event: any) => (matchHandle(item))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rowspan, (itemIndex) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                (itemIndex === 1)
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 0,
                      class: "titleColumn",
                      rowspan: item.rowspan
                    }, "订单", 8, _hoisted_7))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, _toDisplayString(item.orderList[itemIndex - 1]?.categoryAlias), 1),
                _createElementVNode("td", null, _toDisplayString(formatNumber(item.orderList[itemIndex - 1]?.amount)), 1),
                (itemIndex === 1)
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 1,
                      rowspan: item.rowspan
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                (itemIndex === 1)
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 2,
                      class: "titleColumn",
                      rowspan: item.rowspan
                    }, "成本", 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, _toDisplayString((item.costRtList || [])[itemIndex - 1]?.id), 1),
                _createElementVNode("td", null, _toDisplayString((item.costRtList || [])[itemIndex - 1]?.typeAlias), 1),
                _createElementVNode("td", null, _toDisplayString(formatNumber( (item.costRtList || [])[itemIndex - 1]?.credit || (item.costRtList || [])[itemIndex - 1]?.debit  )), 1),
                (itemIndex === 1)
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 3,
                      rowspan: item.rowspan
                    }, null, 8, _hoisted_10))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  (item.costRtList && item.costRtList[itemIndex - 1])
                    ? (_openBlock(), _createBlock(_component_el_link, {
                        key: 0,
                        onClick: ($event: any) => (modifyHandle({...item.costRtList[itemIndex - 1], orderId: item.id}))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 256))
          ], 64))
        }), 256))
      ])), [
        [_directive_loading, _unref(MI_identify)]
      ])
    ], 4),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100, 500, 1000, 2000],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "自动匹配",
      modelValue: isShowAutoMatch.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isShowAutoMatch).value = $event)),
      width: "500px"
    }, {
      default: _withCtx(() => [
        (isShowAutoMatch.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: autoMatchConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改",
      top: "20vh",
      modelValue: modifyFg.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modifyFg).value = $event)),
      width: "430px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submitModify,
          loading: isLoadingModify.value
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (modifyFg.value)
          ? (_openBlock(), _createBlock(_component_el_cascader, {
              key: 0,
              modelValue: modifyValue.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modifyValue).value = $event)),
              options: _unref(modfiyOption)
            }, null, 8, ["modelValue", "options"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "匹配记录",
      modelValue: isShowRecord.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isShowRecord).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "mb-10",
          type: "primary",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (autoMatchHandle()))
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          border: "",
          data: _unref(RecordDt),
          "max-height": '500px'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "开始时间",
              prop: "matchStartAt"
            }),
            _createVNode(_component_el_table_column, {
              label: "结束时间",
              prop: "matchEndAt"
            }),
            _createVNode(_component_el_table_column, {
              label: "创建时间",
              prop: "createdAt",
              formatter: _unref(formatTime)
            }, null, 8, ["formatter"]),
            _createVNode(_component_el_table_column, {
              label: "执行人",
              prop: "createdName"
            }),
            _createVNode(_component_el_table_column, {
              label: "执行状态",
              prop: "status"
            }),
            _createVNode(_component_el_table_column, {
              label: "信息",
              prop: "message"
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, _unref(RecordFg)]
        ]),
        _hoisted_14,
        _createVNode(_component_el_pagination, {
          background: "",
          small: "",
          total: _unref(RecordTotal),
          currentPage: _unref(RecordPage),
          "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => (_isRef(RecordPage) ? (RecordPage).value = $event : null)),
          "page-size": _unref(RecordSize),
          "onUpdate:page-size": _cache[8] || (_cache[8] = ($event: any) => (_isRef(RecordSize) ? (RecordSize).value = $event : null)),
          "page-sizes": [10, 30, 50, 100, 500, 1000, 2000],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(RecordPagePgCg),
          onSizeChange: _unref(RecordSzCg)
        }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
        _hoisted_15
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})